import React from 'react'
import {
    Container,
    Row,
    Col,
    Label,
    Input,
    Button,
    Table,
} from 'reactstrap'
import {
    CustomAddonItem,
} from '../../model/Sign'
import { formatAsDollarValue, moneyText } from '../../model/Formatting'

class SquareInchPriceModalController extends React.Component{

    constructor(props) {
        super(props)
        const model = []
        for (let i = 0; i < props.model.length; i++) {
            model.push(CustomAddonItem.from(props.model[i]))
        }
        this.state = {
            'model': model,
        }
    }

    // MARK: Updating state

    updateItem(property, index, newValue) {
        const items = this.state.model
        items[index][property] = newValue
        this.setState({
            'model': items,
        })
    }

    addButtonClicked() {
        const model = this.state.model
        model.push(new CustomAddonItem())
        this.setState({
            'model': model,
        })
    }

    saveButtonClicked() {
        const model = this.state.model
        this.props.onUpdate(model, this.totalValue())
        this.props.closeModal()
    }

    totalValue() {
        if (this.state.model.length === 0) {
            return 0
        }

        return this.state.model
            .map((x) => Number.parseFloat(x.value))
            .reduce((lhs, rhs) => lhs + rhs)
    }

    renderRows() {
        return this.state.model.map((value, index) => {
            return <tr>
                <td>
                    <Input
                        value={value.label}
                        onChange={(e) => this.updateItem('label', index, e.target.value)} />
                </td>
                <td>
                    <Input
                        value={value.value}
                        onChange={(e) => this.updateItem('value', index, e.target.value)} />
                </td>
                <td>
                    <Button
                        color="danger"
                        onClick={() => {
                            const newList = this.state.model.splice(0, index)
                            newList.push(...this.state.model.splice(1))
                            this.setState({
                                'model': newList,
                            })
                        }}>Delete</Button>
                </td>
            </tr>
        })
    }

    render() {
        return (
            <Container>
                <Row>
                    <Col>
                        <Label style={{
                            'fontSize': '20px',
                            'fontWeight': '500',
                        }}
                            >{this.props.title || 'Square Inch Price Calculator'}</Label>
                    </Col>
                </Row>
                <Row><Col><div style={{'overflowX': 'auto'}}><Table>
                    <thead>
                        <tr>
                            <th className="text-center label-weight" style={{'minWidth': '400px'}}>Description</th>
                            <th className="text-center label-weight" style={{'minWidth': '100px'}}>Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderRows()}
                        <tr>
                            <td><Label style={{
                                'fontWeight': '500',
                            }}>Total: </Label></td>
                            <td><Label><span text={moneyText(this.totalValue())}>{formatAsDollarValue(this.totalValue())}</span></Label></td>
                        </tr>
                    </tbody>
                </Table></div></Col></Row>
                <Row>
                    <Col style={{'textAlign': 'right'}}>
                        <Button style={{
                            'marginTop': '8px',
                            'marginBottom': '8px'
                        }}
                        color='success' onClick={(e) => this.addButtonClicked()}>Add</Button>
                    </Col>
                </Row>
                <Row>
                    <Col style={{'textAlign': 'right'}}>
                        <Button style={{
                            'marginTop': '8px',
                            'marginBottom': '8px',
                        }}
                        color='primary' onClick={(e) => this.saveButtonClicked()}>Save</Button>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export { SquareInchPriceModalController }

